<div class="delete-single-viewer-container">
  @if (!confirmingDeletion()) {
    <button
      accredible-button-icon
      icon="delete"
      size="small"
      color="natural"
      [attr.data-cy]="'btn-cancel-invitation-' + viewerId()"
      (click)="toggleRowDelete($event)"></button>
  } @else {
    <db-delete-viewer-confirmation
      [viewerId]="viewerId()"
      (confirmDeletion)="deleteInvitation.emit(this.viewerId())"
      (cancelDeletion)="toggleRowDelete()" />
  }
</div>
